<template>
  <Catalogs
    title="Теги заявок на подбор"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'RecruitTagAdd'"
    :route-edit="'RecruitTagEdit'"
    :route-view="'RecruitTagView'"
    :route-path="'/recruit_tags'"
    :can-edit="canEditRecruitTagCatalogs()"
  >
    <template #name-tag="{ item }">
      <b-badge pill :style="getBadgeStyle(item.color)" class="px-2 py-1">
        {{ item.name }}
      </b-badge>
    </template>
  </Catalogs>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
  import helpers from "../../../utilites/helpers";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "RecruitTags",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions, helpers
  ],
  methods: {
    async fetchData(data) {
      return await this.getRecruitTags(data);
    },
    canEditRecruitTagCatalogs() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_TAG_EDIT]);
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitTags/RecruitTags.vue